import moment from "moment";
import { Tooltip } from "antd";
import { BiErrorCircle } from "react-icons/bi";
import NumberFormat from "react-number-format";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";

export const removeLiNumbers = (t: string) => t.replace(/^([\d]+\.*)+/, "");

export const numberToPercentageWallet = (value?: number, toFixed = 2) => {
  const number = typeof value === "number" ? value : 0;
  return `${Number(number * 100).toLocaleString("pt-br", {
    minimumFractionDigits: toFixed,
    maximumFractionDigits: toFixed,
  })}%`;
};

export const onlyNumbersToPhone = (value: string) =>
  value.replace(/[()_.%-/\s/]/g, "");

export function numberToPhone(sequenciaNumeros: string) {
  const numeroFormatadoRegex = /^\(\d{2}\) \d{5}-\d{4}$/;
  if (numeroFormatadoRegex.test(sequenciaNumeros)) return sequenciaNumeros;
  if (String(sequenciaNumeros).length !== 11) return '';

  const ddd = sequenciaNumeros.slice(0, 2);
  const primeiraParte = sequenciaNumeros.slice(2, 7);
  const segundaParte = sequenciaNumeros.slice(7);

  return `(${ddd}) ${primeiraParte}-${segundaParte}`;
}

export const formatCurrency = (value: number, prefix = "R$ ") => {
  return (
    <NumberFormat
      prefix={prefix}
      decimalScale={2}
      displayType="text"
      decimalSeparator=","
      thousandSeparator="."
      fixedDecimalScale={true}
      value={
        value?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) || 0
      }
    />
  );
};

export const formatCurrencySmart = (value: number, prefix = "R$ ") => {
  // Verifica se o valor termina com 9,99 (ex: 4759.99, 123.99, etc.)
  const has99Cents = Math.abs(value % 1 - 0.99) < 0.001;
  
  // Se termina com 9,99, arredonda para cima
  const finalValue = has99Cents ? Math.ceil(value) : value;
  
  return (
    <NumberFormat
      prefix={prefix}
      decimalScale={2}
      displayType="text"
      decimalSeparator=","
      thousandSeparator="."
      fixedDecimalScale={true}
      value={
        finalValue?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) || 0
      }
    />
  );
};

export const numberToCurrency = (value: number) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  return formatter.format(value)
}

export const signal = (n: number) => (n > 0 ? "+" : n < 0 ? "" : "");

export const arrow = (n: number) => (n > 0 
  ? <AiOutlineArrowUp style={{fontSize: "14px", marginBottom: '-2px'}}/> 
  : n < 0 
  ? <AiOutlineArrowDown style={{fontSize: "14px", marginBottom: '-2px'}}/> 
  : "");

export const negativeToPositive = (n: number) => (n < 0 ? n * -1 : n);

export const numberToPercentage = (value?: number, toFixed = 2) => {
  const number = typeof value === "number" ? value : 0;
  return `${Number(number * 100).toLocaleString("pt-br", {
    minimumFractionDigits: toFixed,
    maximumFractionDigits: toFixed,
  })}%`;
};

export const currencyToNumber = (value: string, prefix = "R$") =>
  Number(value?.replace(prefix, "").replace(/\./g, "").replace(/,/g, ".")) || 0;

export const replaceDotByComma = (value: number) => {
  return String(value).replace(/\./g, ",");
};

export const ErrorIcon = (
  <Tooltip title="Este campo é obrigatório">
    <BiErrorCircle size={24} className="error-icon" />
  </Tooltip>
);

export const zero = (n: number) => (n < 10 ? `0${n}` : `${n}`);

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const day = zero(date.getDate());
  const month = zero(date.getMonth() + 1);
  return `${day}/${month}/${year}`;
};

export const formatDateHour = (dateString: string) =>
  `${moment(dateString).format("DD/MM/YYYY")} às ${moment(dateString).format(
    "HH:mm"
  )}`;
